import FileSaver from 'file-saver';
import { buildAPIPipeUrl, buildAPIUrl, responseInterceptor } from '.';
import { ImageModel, AISummaryInstructionModel, SaveVoteResponse } from '@/types';

export const downloadImages = async (mediaIds: number[] | ImageModel[]): Promise<void> => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${await buildAPIPipeUrl()}/umbraco/Api/ArticleTools/GetImages2`;
  form.style.display = 'none';
  form.target = '_blank';

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'jsonPayload';
  input.value = JSON.stringify(mediaIds);

  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const downloadImage = async (image: ImageModel): Promise<void> => {
  const filename = image.imageUrl.split('#')[0].split('?')[0].split('/').pop();
  FileSaver.saveAs(`${await buildAPIPipeUrl()}/umbraco/Api/ArticleTools/GetImage?imageId=${image.mediaId}`, filename);
};

export const getAISummaryInstruction = async (): Promise<AISummaryInstructionModel> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ArticleTools/GetAISummaryInstruction`),
  );

  return response.json();
};

export const getAISummaryContent = async (instructionId: number, reportId: number): Promise<string> => {
  const params = new URLSearchParams({
    instructionId: instructionId.toString(),
    reportId: reportId.toString(),
  });
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ArticleTools/GetAISummaryContent?${params.toString()}`),
  );

  return response.json();
};

export const saveToScrapbookWithPath = async (
  saveObject: {
    path: string;
    contentType: string;
    content: string;
  },
  userId?: string,
): Promise<{ succeeded: boolean; message?: string }> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/services/scrapbook/writeText`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...saveObject,
        userId,
      }),
    }),
  );

  return response.json();
};

export const getReportPdfLink = async (reportFullUrl: string, reportId: number): Promise<string> => {
  const params = new URLSearchParams({
    reportFullUrl: reportFullUrl.toString(),
    reportId: reportId.toString(),
  });
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ArticleTools/getReportPdfLink?${params.toString()}`),
  );

  return response.json();
};

export const getIPLogonReportPdfLink = async (reportFullUrl: string, reportId: number): Promise<string> => {
  const params = new URLSearchParams({
    reportFullUrl: reportFullUrl.toString(),
    reportId: reportId.toString(),
  });
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ArticleTools/GetIPLogonReportPdfLink?${params.toString()}`),
  );

  return response.json();
};

export const saveVote = async (pollId: string, optionIndx: string, userId: string): Promise<SaveVoteResponse> => {
  const params = new URLSearchParams({
    pollId: pollId.toString(),
    optionIndx: optionIndx.toString(),
    userId: userId.toString(),
  });
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/ArticleTools/SaveVote?${params.toString()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }),
  );
  return response.json();
};
